export function getSessionStorageItem<T>(key: string) {
  if (typeof window === 'undefined') return undefined;

  const item = sessionStorage.getItem(key);
  if (item != null && item.length > 0) {
    return JSON.parse(item) as T;
  }
}
